export * from "./Presocratics";
export * from "./HellenisticSchools";
export * from "./Socrates";
export * from "./Plato";
export * from "./Aristotle";

export const ancientPhilosophyItems = {
  Presocráticos: {
    path: "/filosofia-antigua/presocraticos",
    subtopics: {
      "¿Quiénes eran?": {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "quienesEranPresocraticos",
      },
      Tales: {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "tales",
      },
      Anaximandro: {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "anaximandro",
      },
      Anaxímenes: {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "anaximenes",
      },
      "Heráclito de Efeso": {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "heraclito",
      },
      Parménides: {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "parmenides",
      },
      Pitágoras: {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "pitagoras",
      },
      Empédocles: {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "empedocles",
      },
      Anaxágoras: {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "anaxagoras",
      },
      Demócrito: {
        path: "/filosofia-antigua/presocraticos",
        scrollToId: "democrito",
      },
    },
  },
  "Escuelas helenísticas": {
    path: "/filosofia-antigua/escuelas-helenisticas",
    subtopics: {
      Cínicos: {
        path: "/filosofia-antigua/escuelas-helenisticas",
        scrollToId: "cinicos",
      },
      Epicureos: {
        path: "/filosofia-antigua/escuelas-helenisticas",
        scrollToId: "epicureos",
      },
      Escépticos: {
        path: "/filosofia-antigua/escuelas-helenisticas",
        scrollToId: "escepticos",
      },
      Estoicos: {
        path: "/filosofia-antigua/escuelas-helenisticas",
        scrollToId: "estoicos",
      },
    },
  },
  Sócrates: {
    path: "/filosofia-antigua/socrates",
  },
  Platón: {
    path: "/filosofia-antigua/platon",
  },
  Aristóteles: {
    path: "/filosofia-antigua/aristoteles",
  },
};
